import React, { createContext, useContext, useEffect, useState } from "react";
import { getConversations } from "../api/messageService";
import { useUser } from "../components/UserProvider";

const MessagesContext = createContext();

export const useMessages = () => useContext(MessagesContext);

export const MessagesProvider = ({ children }) => {
  const [unreadCount, setUnreadCount] = useState(0);
  const { user } = useUser();

  useEffect(() => {
    if (!user) return;
    const fetchUnread = async () => {
      try {
        const conversations = await getConversations();
        const count = conversations.filter(
          (c) =>
            c.last_message &&
            !c.last_message.is_read &&
            c.last_message.sender !== user.id
        ).length;
        setUnreadCount(count);
      } catch {
        setUnreadCount(0);
      }
    };
    fetchUnread();
    // Opsiyonel: belirli aralıklarla güncellemek için interval ekleyebilirsiniz
  }, [user]);

  return (
    <MessagesContext.Provider value={{ unreadCount }}>
      {children}
    </MessagesContext.Provider>
  );
};
